"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
async function SVGString2Image(svgString, width, height, format = 'png') {
    const imgsrc = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svgString))); // Convert SVG string to data URL
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    if (!context)
        return null;
    canvas.width = width;
    canvas.height = height;
    const p = new Promise((resolve, reject) => {
        const image = new Image();
        image.onload = function () {
            context.clearRect(0, 0, width, height);
            context.drawImage(image, 0, 0, width, height);
            context.drawImage(image, 0, 0, width, height);
            canvas.toBlob(function (blob) {
                //var filesize = Math.round( blob.length/1024 ) + ' KB';
                //if ( callback ) callback( blob, filesize );
                resolve(blob);
            });
        };
        image.src = imgsrc;
    });
    const blob = await p;
    return blob;
}
exports.default = SVGString2Image;
